// "use client";

// import { useState, useEffect } from "react";
// import "../styles/howwemake.css"

// import testi1 from "../assets/testimonials/testi1.jpeg";
// import testi2 from "../assets/testimonials/testi2.jpeg";
// import testi3 from "../assets/testimonials/testi3.jpeg";
// import testi4 from "../assets/testimonials/testi4.jpeg";
// import testi5 from "../assets/testimonials/testi5.jpeg";

// const testimonials = [
//   { id: 1, image: testi1 },
//   { id: 2, image: testi2 },
//   { id: 3, image: testi3 },
//   { id: 4, image: testi4 },
//   { id: 5, image: testi5 },
// ];

// export default function TestimonialCarousel() {
//   const [active, setActive] = useState(2);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActive((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   const getPosition = (index) => {
//     const diff = index - active;

//     if (diff === 0) return "center";
//     if (diff === -1 || diff === testimonials.length - 1) return "left1";
//     if (diff === 1 || diff === -(testimonials.length - 1)) return "right1";
//     if (diff === -2 || diff === testimonials.length - 2) return "left2";
//     if (diff === 2 || diff === -(testimonials.length - 2)) return "right2";

//     return "hidden";
//   };

//   return (
//     <section className="testimonial-section">
//       <h2 className="heading">What Our Clients Say</h2>
//       <hr style={{ width: "350px", height: "2px", background: "#1976d2", border: "none", margin: "auto", marginTop: "-60px" }} />

//       <div className="carousel">
//         {testimonials.map((item, index) => {
//           const position = getPosition(index);

//           return (
//             <div
//               key={item.id}
//               className={`card ${position}`}
//               onClick={() => setActive(index)}
//             >
//               <img src={item.image} alt="" />
//             </div>
//           );
//         })}
//       </div>
//     </section>
//   );
// }


"use client";

import { useState, useEffect } from "react";
import "../styles/howwemake.css";
import axios from "axios";
import Constant from "../helper/Constant";

export default function TestimonialCarousel() {
  const [active, setActive] = useState(0);
  const [testimonials, setTestimonials] = useState([]);

  // Fetch testimonials from API
  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(
        Constant.getUrls.getAllTestimonials + "?page=1&limit=100"
      );
      // console.log(response);
      
      setTestimonials(response.data.data || []);
    } catch (error) {
      console.error("Error fetching testimonials:", error);
    }
  };

  // Call API on mount
  useEffect(() => {
    fetchTestimonials();
  }, []);

  // Auto slide (only when data is available)
  useEffect(() => {
    if (testimonials.length === 0) return;

    const interval = setInterval(() => {
      setActive((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [testimonials]);

  const getPosition = (index) => {
    const diff = index - active;
    const length = testimonials.length;

    if (diff === 0) return "center";
    if (diff === -1 || diff === length - 1) return "left1";
    if (diff === 1 || diff === -(length - 1)) return "right1";
    if (diff === -2 || diff === length - 2) return "left2";
    if (diff === 2 || diff === -(length - 2)) return "right2";

    return "hidden";
  };

  return (
    <section className="testimonial-section">
      <h2 className="heading">What Our Clients Say</h2>

      <hr
        style={{
          width: "350px",
          height: "2px",
          background: "#1976d2",
          border: "none",
          margin: "auto",
          marginTop: "-60px",
        }}
      />

      <div className="carousel">
        {testimonials.map((item, index) => {
          const position = getPosition(index);

          return (
            <div
              key={item._id || index}
              className={`card ${position}`}
              onClick={() => setActive(index)}
            >
              <img
                src={Constant.imageDomain + item.image}
                alt="testimonial"
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}